import { Link } from "react-router-dom";
import { CATEGORIES } from "../lib/constants";
import { CATEGORY_LABELS_FR } from "../lib/i18n";
import { useLanguage } from "../context/LanguageContext";
import { SocialIcons } from "./SocialIcons";
import { FooterNewsletter } from "./FooterNewsletter";

export const Footer = () => {
  const { lang, t } = useLanguage();
  const catLabel = (c) => (lang === "fr" ? (CATEGORY_LABELS_FR[c.id] || c.label) : c.label);
  return (
  <footer className="bg-[#12234A] text-white mt-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <Link to="/" data-testid="footer-logo-link" onClick={() => window.scrollTo({ top: 0, behavior: window.location.pathname === "/" ? "smooth" : "auto" })}>
            <img src={`${process.env.PUBLIC_URL}/logo-footer.png`} alt="CritterPosts.ca" className="h-14 w-auto" />
          </Link>
          <p className="mt-3 text-sm text-slate-300 max-w-xs">
            {t("footer_tagline")}
          </p>
          <SocialIcons />
        </div>
        <div>
          <h4 className="font-semibold mb-3 text-sm uppercase tracking-wider text-slate-400">{t("footer_browse")}</h4>
          <ul className="space-y-2 text-sm text-slate-300">
            {CATEGORIES.filter((c) => c.id !== "all").map((c) => (
              <li key={c.id}>
                <Link to={`/browse?category=${c.id}`} className="hover:text-[#F5551E] transition-colors">{catLabel(c)}</Link>
              </li>
            ))}
            <li><Link to="/litters" data-testid="footer-litters-link" className="hover:text-[#F5551E] transition-colors">{lang === "fr" ? "Portées à venir" : "Upcoming Litters"}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-3 text-sm uppercase tracking-wider text-slate-400">{t("footer_company")}</h4>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><Link to="/about" data-testid="footer-about-link" className="hover:text-[#F5551E] transition-colors">{t("footer_about")}</Link></li>
            <li><Link to="/how-it-works" data-testid="footer-how-link" className="hover:text-[#F5551E] transition-colors">{t("footer_how")}</Link></li>
            <li><Link to="/litter-journey" data-testid="footer-litter-journey-link" className="hover:text-[#F5551E] transition-colors">{lang === "fr" ? "Le parcours d'une portée" : "How litters work"}</Link></li>
            <li><Link to="/trust-safety" data-testid="footer-trust-link" className="hover:text-[#F5551E] transition-colors">{t("footer_trust")}</Link></li>
            <li><Link to="/businesses" data-testid="footer-businesses-link" className="hover:text-[#F5551E] transition-colors">Verified Businesses</Link></li>
            <li><Link to="/breeders" data-testid="footer-breeders-link" className="hover:text-[#F5551E] transition-colors">{lang === "fr" ? "Éleveurs vérifiés" : "Verified Breeders"}</Link></li>
            <li><Link to="/get-verified" data-testid="footer-get-verified-link" className="hover:text-[#F5551E] transition-colors">{t("footer_get_verified")}</Link></li>
            <li><Link to="/advertising" data-testid="footer-advertise-link" className="hover:text-[#F5551E] transition-colors">{t("footer_advertise")}</Link></li>
            <li><Link to="/advertising/placements" data-testid="footer-where-ads-link" className="hover:text-[#F5551E] transition-colors">{t("footer_where_ads")}</Link></li>
            <li><Link to="/contact" data-testid="footer-contact-link" className="hover:text-[#F5551E] transition-colors">{t("footer_contact")}</Link></li>
          </ul>
        </div>
        <div className="col-span-2 md:col-span-1">
          <h4 className="font-semibold mb-3 text-sm uppercase tracking-wider text-slate-400">{t("footer_safety_h")}</h4>
          <p className="text-sm text-slate-300">{t("footer_safety_d")}</p>
          <FooterNewsletter />
        </div>
      </div>
      <div className="border-t border-white/10 mt-10 pt-6 text-sm text-slate-400 flex flex-col sm:flex-row justify-between gap-2">
        <p>© {new Date().getFullYear()} CritterPosts.ca — {t("footer_made")}</p>
        <p className="flex items-center gap-1.5"><Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white transition-colors">{t("footer_privacy")}</Link> · {t("footer_terms")} · {t("footer_cookies")}</p>
      </div>
    </div>
  </footer>
  );
};
